import { DecimalPipe, ViewportScroller } from '@angular/common';
import { Component, inject, Inject, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subscription } from 'rxjs';
import { ApnUtilitiesService } from 'src/app/core/services/data/apn-utilities.service';
import { AuthService } from 'src/app/core/services/auth-security/auth.service';
import { InvoiceService } from 'src/app/core/services/data/invoice.service';
import { LotService } from 'src/app/core/services/data/lot.service';
import { MessageService } from 'src/app/core/services/broadcast/message-service';
import { QueryMessageService } from 'src/app/core/services/broadcast/MessageDispatchingService';
import { ActiveTaxList } from 'src/app/shared/entities/ActiveTaxList';
import { AddedRevenue } from 'src/app/shared/entities/AddedRevenue';
import { AddedRevenueDataForGSearchResults } from 'src/app/shared/entities/AddedRevenueDataForGSearchResults';
import { AddedRevenueValidation } from 'src/app/shared/entities/AddedRevenueValidation';
import { AddRevenue } from 'src/app/shared/entities/AddRevenue';
import { dbErrorEntry } from 'src/app/shared/entities/dbErrorEntry';
import { InvoiceAdjustmentReasons } from 'src/app/shared/entities/InvoiceAdjustmentReasons';
import { QuickSearchResults } from 'src/app/shared/entities/QuickSearchResults';
import { RevenueHistoricalPostAdjustments } from 'src/app/shared/entities/RevenueHistoricalPostAdjustments';
import { RevenuePostAdjustmentQuery } from 'src/app/shared/entities/RevenuePostAdjustmentQuery';
import { RevenuePostAdjustments } from 'src/app/shared/entities/RevenuePostAdjustments';
import { RevenueTypes } from 'src/app/shared/entities/RevenueTypes';
import { ConfirmAddTaxComponent } from '../../dialog/confirm-add-tax.component';
import { ConfirmRemoveTaxComponent } from '../../dialog/confirm-remove-tax.component';
import { NotifyNoTaxOnlyComponent } from '../../dialog/notify-no-tax-only.component';
import { NotifyTaxOnlyComponent } from '../../dialog/notify-tax-only.component';
import { QuickstartStateService } from 'src/app/core/services/state/quickstart-state.service';
import { FormGroup } from '@angular/forms';
import { ErrorDialogStopComponent } from 'src/app/core/dialog/error-dialog-stop/error-dialog-stop.component';
import { IParkerId } from 'src/app/profiles/companies/company-components/parker-detail/parker-detail.component';
import { AppGeneralStateService } from 'src/app/app-general-state.service';

@Component({
  selector: 'app-add-revenue',
  templateUrl: './add-revenue.component.html',
  styleUrls: ['./add-revenue.component.scss'],
})
export class AddRevenueComponent implements OnInit, OnChanges, OnDestroy {
  @Input() invoiceNumber: string;
  invoicePeriod: string;
  customerName: string;
  invoiceAmount: number;
  invoiceBalance: number;
  activeTaxListForLot: ActiveTaxList[] = [];
  baseTaxToCalcFrom: number = 0;
  totalTaxRate: number = 0;
  calcTaxAmount: number = 0;
  calcTotalAmount: number = 0;
  calcRate: number = 0;
  netTaxAmount: number = 0;
  revenueTypes: RevenueTypes[] = [];
  currentRevenueRate: number = 0;
  addedRevenueQuantity: number = 0;
  addedRevenueRate: number = 0;
  subtotalCalcedAddedRevenue: number = 0;
  isTaxCheckboxReadOnly: boolean = true;

  totalCalcedAddedRevenue: number = 0;
  revenueDescription: string = '';
  submitRevenueValidated: boolean = true;
  addedRevenueValidation: AddedRevenueValidation = new AddedRevenueValidation();
  appliedRevenue: AddedRevenue[] = [];
  showRevenuePostAdjustment: boolean = false;
  invoiceAdjustmentReasons: InvoiceAdjustmentReasons[] = [];
  revenuePostAdjustmentAmount: number = 0;
  flagDisablePostRevenueAdjustmentButton: boolean = true;
  revenuePostAdjustments: RevenueHistoricalPostAdjustments[] = [];
  taxableRevenueShouldBeApplied: boolean = true;
  subInvoiceDetail: Subscription;
  errorMessage: string;
  invoiceDetailData: QuickSearchResults;
  postAdjustmentRevenueAdjustmentId: number;
  revenuePostAdjustmentData: RevenuePostAdjustments;
  currentWorkingLotNumber: string;
  msgService: QueryMessageService;
  revenueBeingAdded: boolean = false;
  taxForRevenueAdjustmentTax: number = 0;
  typeRevenueCalculation: string = 'NET';
  tempHideOriginalLine: boolean = false;
  revenueCodeSelectedNet: string = '';
  revenueCodeSelectedGross: string = '';

  //Gross Calculator Vars
  showGrossCalc: boolean = true;
  grossQuantity: number = 0;
  grossRate: number = 0;
  grossDisplayNet: number = 0;
  grossTaxDisplayRate: number = 0;
  grossTotalTaxRate: number = 0;
  grossDisplayAmount: number = 0;
  grossDisplayTaxAmount: number = 0;
  netRate: number = 0;
  revenueDescriptionGross: string = '';
  inputValidatedGross: boolean = false;
  addRevenueIsTaxableCheckBoxGross: boolean = true;

  //Net Calculator Vars
  netRateValue: number = 0;
  netQuantity: number = 0;
  netTotalTaxRate: number = 0;
  netDisplayTotalNet: number = 0;
  netDisplayTaxAmount: number = 0;
  netDisplayTotalAmount: number = 0;
  revenueDescriptionNet: string = '';
  inputValidatedNet: boolean = false;
  addRevenueIsTaxableCheckBoxNet: boolean = true;

  //Services
  _appGeneralState = inject(AppGeneralStateService);

  constructor(
    private dialog: MatDialog,
    private decimalPipe: DecimalPipe,
    private invoiceService: InvoiceService,
    private _snackBar: MatSnackBar,
    private authService: AuthService,
    private viewportScroller: ViewportScroller,
    private lotService: LotService,
    private apnUtilityService: ApnUtilitiesService,
    messageDispatchService: QueryMessageService,
    private messageService: MessageService,
    private quickstartStateService: QuickstartStateService,
  ) {
    this.msgService = messageDispatchService;
  }

  ngOnInit(): void {
    this.currentWorkingLotNumber = this._appGeneralState.currentLotNumber;
    this.initAddedRevenueStep1();
    this.onScrollToTop();
  }

  onScrollToTop(): void {
    this.viewportScroller.scrollToPosition([0, 0]);
  }

  ngOnChanges(changes: SimpleChanges): void {}

  ngOnDestroy(): void {
    this.subInvoiceDetail.unsubscribe();
  }

  initAddedRevenueStep1(): void {
    this.getInvoiceDetailBalancesForInvoiceNumber(this.invoiceNumber);
  }

  onSetTypeRevenueCalc(typeRevenue: string): void {
    this.typeRevenueCalculation = typeRevenue;
    this.onResetAddRevenueDataGross();
    this.onResetAddRevenueDataNet();
  }

  initAddedRevenueStep2(): void {
    this.getRevenueAdjustmentList(this.invoiceNumber);
    this.getRevenuePostAdjustmentsByInvoiceNumber(this.invoiceNumber, this._appGeneralState.currentLotNumber);
  }

  getRevenuePostAdjustmentsByInvoiceNumber(invoiceNumber: string, lotNumber: string): void {
    let queryCriteria: RevenuePostAdjustmentQuery = new RevenuePostAdjustmentQuery();
    queryCriteria.lotNumber = lotNumber;
    queryCriteria.invoiceNumber = invoiceNumber;

    this.invoiceService.getRevenuePostAdjustmentsCompletedByInvoiceNumber(queryCriteria).subscribe(
      (adjustmentListResults) => {
        this.revenuePostAdjustments = adjustmentListResults;
      },
      (err: any) => {
        let errorLogEntry: dbErrorEntry = new dbErrorEntry();

        errorLogEntry.Location = 'Err: invoice-add-revenue.ts::getRevenuePostAdjustmentsCompletedByInvoiceNumber().';
        errorLogEntry.errorMessage = JSON.stringify(err);
        this.apnUtilityService.logErrorToDB(errorLogEntry);
      },
      () => {},
    );
  }

  getActiveTaxListForLotNumber(lotNumber: string) {
    this.lotService.getActiveTaxListByLotNumber(lotNumber).subscribe(
      (taxListForLot) => {
        this.activeTaxListForLot = taxListForLot;
      },
      (err: any) => {
        let errorLogEntry: dbErrorEntry = new dbErrorEntry();

        errorLogEntry.Location = 'Err: invoice-add-revenue.ts::getActiveTaxListForLotNumber().';
        errorLogEntry.errorMessage = JSON.stringify(err);
        this.apnUtilityService.logErrorToDB(errorLogEntry);
      },
      () => {
        this.getRevenueAdjustmentReasonsList(this._appGeneralState.currentLotNumber);
        this.grossTotalTaxRate = this.calculateTotalTaxRate();
      },
    );
  }

  getRevenueAdjustmentReasonsList(lotNumber: string) {
    this.invoiceService.getRevenueAdjustmentsReasonsForLotNumber(lotNumber).subscribe(
      (x) => {
        this.invoiceAdjustmentReasons = x;
      },
      (err: any) => {
        let errorLogEntry: dbErrorEntry = new dbErrorEntry();

        errorLogEntry.Location = 'Err: invoice-add-revenue.ts::getRevenueAdjustmentReasonsList().';
        errorLogEntry.errorMessage = JSON.stringify(err);
        this.apnUtilityService.logErrorToDB(errorLogEntry);
      },
      () => {
        this.initAddedRevenueStep2();
      },
    );
  }

  cancelRevenuePostAdjustmentSubmit(): void {
    this.showRevenuePostAdjustment = false;
  }

  getRevenueTypesForLotNumber(lotNumber: string) {
    let tempRevenueTypes: RevenueTypes[];
    this.invoiceService.getRevenueTypesForLotNumber(lotNumber).subscribe(
      (revenueTypes) => {
        tempRevenueTypes = revenueTypes;
      },
      (err: any) => {
        let errorLogEntry: dbErrorEntry = new dbErrorEntry();

        errorLogEntry.Location = 'Err: invoice-add-revenue.ts::getRevenueTypesForLotNumber().';
        errorLogEntry.errorMessage = JSON.stringify(err);
        this.apnUtilityService.logErrorToDB(errorLogEntry);
      },
      () => {
        this.revenueTypes = tempRevenueTypes;
        this.getActiveTaxListForLotNumber(this._appGeneralState.currentLotNumber);
      },
    );
  }

  onSubmitPostRevenueAdjustment(): void {
    let postAdjustmentReason: string;

    var e = document.getElementById('revenuePostAdjustmentReason') as HTMLSelectElement;
    var sel = e.selectedIndex;
    var opt = e.options[sel];
    postAdjustmentReason = (<HTMLOptionElement>opt).value;

    this.revenuePostAdjustmentData.adjustmentReasonId = +postAdjustmentReason;

    this.postRevenuePostAdjustment();
  }

  postRevenuePostAdjustment(): void {
    let rowsReturned: number;
    let postAdjustmentBalanceData: AddedRevenueDataForGSearchResults = new AddedRevenueDataForGSearchResults();
    let adjustmentAmount: number =
      this.revenuePostAdjustmentData.adjustedAmount + this.revenuePostAdjustmentData.adjustedTaxAmount * -1;
    this.revenuePostAdjustmentData.adjustedAmount =
      this.revenuePostAdjustmentData.adjustedAmount + this.revenuePostAdjustmentData.adjustedTaxAmount * -1;
    this.revenuePostAdjustmentData.lotNumber = this.currentWorkingLotNumber;

    let adjustmentInvoiceNumber: string = this.revenuePostAdjustmentData.invoiceNumber;

    this.invoiceService.postAddRevenuePostAdjustment(this.revenuePostAdjustmentData).subscribe(
      (numberOfRows) => {
        rowsReturned = numberOfRows;
      },
      (err: any) => {
        let errorLogEntry: dbErrorEntry = new dbErrorEntry();

        errorLogEntry.Location = 'Err: invoice-add-revenue.ts::postAddRevenuePostAdjustment().';
        errorLogEntry.errorMessage = JSON.stringify(err);
        this.apnUtilityService.logErrorToDB(errorLogEntry);

        this.messageService.addExceptionMessage(
          'An error occurred while submitting a revenue post adjustment. Please review the adjustment data and resubmit. If the error continues to occur, please contact APN Support. Error Id #: ' +
            err.error,
        );
      },
      () => {
        try {
          postAdjustmentBalanceData.amountOfChange = adjustmentAmount;
          postAdjustmentBalanceData.invoiceNumber = adjustmentInvoiceNumber;

          //todo:datafetch
          //this.updateQuickSearchResultsWithUpdatedBalances(this.workingInvoiceNumber);
          this.showRevenuePostAdjustment = false;
          this.resetPostRevenueAdjustmentElements();
          this.getRevenueAdjustmentList(this.invoiceNumber);
          this.getRevenuePostAdjustmentsByInvoiceNumber(this.invoiceNumber, this._appGeneralState.currentLotNumber);
          this.getInvoiceDetailBalancesForInvoiceNumber(this.invoiceNumber);
        } catch (err) {}

        this._snackBar.open('This post revenue adjustment has been successfully submitted.', '', { duration: 3000 });
      },
    );
  }

  resetPostRevenueAdjustmentElements(): void {
    (<HTMLOptionElement>document.getElementById('revenuePostAdjustmentReason')).value = '0';
    (<HTMLInputElement>document.getElementById('amountRevenuePostAdjustment')).value = '0';
  }

  onRevenuePostAdjustmentReasonChange(): void {
    let revenueAdjustmentIdReason: string = (<HTMLOptionElement>document.getElementById('revenuePostAdjustmentReason'))
      .value;

    if (revenueAdjustmentIdReason === '0') {
      this.flagDisablePostRevenueAdjustmentButton = true;
    } else this.flagDisablePostRevenueAdjustmentButton = false;
  }

  //todo:DataFetch
  getInvoiceDetailBalancesForInvoiceNumber(invoiceNumber: string): void {
    let quickSearchResults: QuickSearchResults;

    this.subInvoiceDetail = this.invoiceService
      .getInvoiceDetailByInvoiceNumber(invoiceNumber, this._appGeneralState.currentLotNumber)
      .subscribe({
        error: (err: any) => {
          let errorLogEntry: dbErrorEntry = new dbErrorEntry();

          errorLogEntry.Location = 'Err: invoice-add-revenue.ts::getInvoiceDetailBalancesForInvoiceNumber().';
          errorLogEntry.errorMessage = JSON.stringify(err);
          this.apnUtilityService.logErrorToDB(errorLogEntry);
        },
        next: (results) => (quickSearchResults = results),
        complete: () => {
          this.invoiceDetailData = quickSearchResults;
          this.setInvoiceDetailData();
          this.getRevenueTypesForLotNumber(this._appGeneralState.currentLotNumber);
        },
      });
  }

  setInvoiceDetailData(): void {
    let ii: number = 0;

    this.invoiceNumber = this.invoiceDetailData.invoiceNumber;
    this.invoiceAmount = this.invoiceDetailData.rate;
    this.invoiceBalance = this.invoiceDetailData.currentBalance;

    this.msgService.currentInvoiceBalance = this.invoiceDetailData.currentBalance;

    if (this.invoiceDetailData.customerName !== '') this.customerName = this.invoiceDetailData.customerName;
    else this.customerName = this.invoiceDetailData.companyName;

    var months = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ];
    var d = new Date(this.invoiceDetailData.invoiceDate);
    var monthName = months[d.getMonth()];
    var year = d.getFullYear();

    this.invoicePeriod = monthName + ', ' + year;
  }

  onShowRevenuePostAdjustment(revenueAdjustmentId: number): void {
    this.showRevenuePostAdjustment = true;
    this.postAdjustmentRevenueAdjustmentId = revenueAdjustmentId;
    this.setPostAdjustmentData(revenueAdjustmentId);
  }

  getCurrentDate(): any {
    var today = new Date();
    var returnDate = '';

    var dd = today.getDate();
    var mm = today.getMonth() + 1;
    var yyyy = today.getFullYear();

    returnDate += `${mm}/${dd}/${yyyy}`;

    return returnDate;
  }

  setPostAdjustmentData(revenueAdjustmentId: number): void {
    let ii: number = 0;
    let totalAdjustmentAmount: number = 0;
    let appliedRevenueAdjustment: AddedRevenue = new AddedRevenue();

    for (ii = 0; ii < this.appliedRevenue.length; ii++) {
      if (this.appliedRevenue[ii].revenueAdjustmentId === revenueAdjustmentId) {
        totalAdjustmentAmount =
          this.appliedRevenue[ii].billingRate * this.appliedRevenue[ii].quantity + this.appliedRevenue[ii].tax;
        let displayAdjustmentAmount: any = this.decimalPipe.transform(totalAdjustmentAmount, '1.2-2')?.toString();
        this.revenuePostAdjustmentAmount = displayAdjustmentAmount;
        appliedRevenueAdjustment = this.appliedRevenue[ii];
      }
    }

    this.revenuePostAdjustmentData = new RevenuePostAdjustments();

    this.revenuePostAdjustmentData.adjustedAmount = totalAdjustmentAmount * -1;
    this.revenuePostAdjustmentData.adjustedTaxAmount = appliedRevenueAdjustment.tax * -1;

    this.revenuePostAdjustmentData.dateEntered = this.getCurrentDate();
    this.revenuePostAdjustmentData.invoiceNumber = appliedRevenueAdjustment.invoiceNumber;
    this.revenuePostAdjustmentData.isLocked = false;
    this.revenuePostAdjustmentData.revenueAdjustmentId = appliedRevenueAdjustment.revenueAdjustmentId;
    this.revenuePostAdjustmentData.revenuePostAdjustmentId = 0;
    this.revenuePostAdjustmentData.revenueType = appliedRevenueAdjustment.revenueType;
    this.revenuePostAdjustmentData.userName = this._appGeneralState.userName;
  }

  DisplayNegativeAddedRevenueDialog(): void {
    const dlgTitle: string = 'Invalid Added Revenue Amount';
    const dlgLine1: string = 'Added Revenue must be greater than $0.';
    const dlgLine2: string = 'Change added revenue amount and submit again.';
    let enterAnimationDuration: string = '0ms';
    let exitAnimationDuration: string = '0ms';

    const dialogRef = this.dialog.open(ErrorDialogStopComponent, {
      data: { dlgTitle: dlgTitle, dlgLine1: dlgLine1, dlgLine2: dlgLine2 },
      width: '450px',
      enterAnimationDuration,
      exitAnimationDuration,
    });
  }

  onSubmitAddedRevenue(): void {
    if (this.revenueBeingAdded) return;

    //Stop this transaction if netDisplayTotalAmount <= 0.00

    if (this.typeRevenueCalculation == 'NET') {
      if (this.netDisplayTotalAmount < 0.01) {
        this.DisplayNegativeAddedRevenueDialog();
        return;
      }
    } else {
      if (this.grossDisplayAmount < 0.01) {
        this.DisplayNegativeAddedRevenueDialog();
        return;
      }
    }

    this.revenueBeingAdded = true;

    let addedRevenueData: AddRevenue = new AddRevenue();
    let revenueAdjustmentId: number = 0;

    addedRevenueData.invoiceNumber = this.invoiceNumber;
    addedRevenueData.lotNumber = this.invoiceDetailData.lotNumber;
    addedRevenueData.sequenceStart = '';
    addedRevenueData.sequenceEnd = '';
    addedRevenueData.userName = this._appGeneralState.userName;

    if (this.typeRevenueCalculation == 'NET') {
      addedRevenueData.revenueType = this.revenueCodeSelectedNet;
      addedRevenueData.description = this.getRevenueTypeNameByRevenueCode(addedRevenueData.revenueType);
      addedRevenueData.quantity = this.netQuantity;
      addedRevenueData.totalRevenue = this.netDisplayTotalAmount;
      addedRevenueData.netRevenue = this.netDisplayTotalNet;
      addedRevenueData.billingRate = this.netRateValue;
      addedRevenueData.comments = this.revenueDescriptionNet;
      addedRevenueData.taxAmount = this.netDisplayTaxAmount;
    } else {
      addedRevenueData.revenueType = this.revenueCodeSelectedGross;
      addedRevenueData.description = this.getRevenueTypeNameByRevenueCode(addedRevenueData.revenueType);
      addedRevenueData.quantity = this.grossQuantity;
      addedRevenueData.totalRevenue = this.grossDisplayAmount;
      addedRevenueData.netRevenue = this.grossDisplayNet;
      addedRevenueData.billingRate = this.netRate;
      addedRevenueData.comments = this.revenueDescriptionGross;
      addedRevenueData.taxAmount = this.grossDisplayTaxAmount;
    }

    if (isNaN(this.taxForRevenueAdjustmentTax)) this.taxForRevenueAdjustmentTax = 0;

    if (this.typeRevenueCalculation == 'GROSS') addedRevenueData.isTaxable = this.addRevenueIsTaxableCheckBoxGross;
    else addedRevenueData.isTaxable = this.addRevenueIsTaxableCheckBoxNet;

    this.invoiceService.postAddedRevenueAdjustment(addedRevenueData, this.activeTaxListForLot).subscribe(
      (newRevenueAdjustmentId) => {
        revenueAdjustmentId = revenueAdjustmentId;
      },
      (err: any) => {
        this.revenueBeingAdded = false;

        let errorLogEntry: dbErrorEntry = new dbErrorEntry();

        errorLogEntry.Location = 'Err: invoice-add-revenue.ts::postAddedRevenueAdjustment().';
        errorLogEntry.errorMessage = JSON.stringify(err);
        this.apnUtilityService.logErrorToDB(errorLogEntry);

        this.messageService.addExceptionMessage(
          'An error occurred while adding revenue. Please review the revenue adjustment data and resubmit. If the error continues to occur, please contact APN Support. Error Id #: ' +
            err.error,
        );
      },
      () => {
        this.revenueBeingAdded = false;

        let totalAdjustmentAmount: number = this.totalCalcedAddedRevenue;

        let dataToAddToGSearchResults: AddedRevenueDataForGSearchResults = new AddedRevenueDataForGSearchResults();
        dataToAddToGSearchResults.invoiceNumber = addedRevenueData.invoiceNumber;
        dataToAddToGSearchResults.amountOfChange = this.totalCalcedAddedRevenue;
        dataToAddToGSearchResults.lotNumber = this.currentWorkingLotNumber;

        this.postAddedRevenueToGSearchResults(dataToAddToGSearchResults);

        this.getRevenueAdjustmentList(this.invoiceNumber);

        this.getInvoiceDetailBalancesForInvoiceNumber(this.invoiceNumber);

        this.onFinishAddRevenueDataGross();
        this.onFinishAddRevenueDataNet();

        this._snackBar.open('This revenue addition has been successfully submitted.', '', { duration: 3000 });
      },
    );

    //reset tax flag variables that user can use to optionally remove tax from calculations
    if (this.typeRevenueCalculation == 'GROSS') this.addRevenueIsTaxableCheckBoxGross = true;
    else this.addRevenueIsTaxableCheckBoxNet = true;

    this.taxableRevenueShouldBeApplied = true;
  }

  postAddedRevenueToGSearchResults(addedRevenueData: AddedRevenueDataForGSearchResults): void {
    let rowsReturned: number;

    this.invoiceService.postAddedRevenueToGSearchResults(addedRevenueData).subscribe(
      (numberOfRows) => {
        rowsReturned = numberOfRows;
      },
      (err: any) => {
        let errorLogEntry: dbErrorEntry = new dbErrorEntry();

        errorLogEntry.Location = 'Err: invoice-add-revenue.ts::postAddedRevenueToGSearchResults().';
        errorLogEntry.errorMessage = JSON.stringify(err);
        this.apnUtilityService.logErrorToDB(errorLogEntry);
      },
      () => {
        //todo: datafetch
        //this.updateQuickSearchResultsBalanceForInvoice(addedRevenueData.invoiceNumber);
        //this.updateQuickSearchResultsWithUpdatedBalances(addedRevenueData.invoiceNumber);
      },
    );
  }

  getRevenueAdjustmentList(invoiceNumber: string) {
    this.invoiceService.getRevenueAdjustmentsForInvoiceNumber(invoiceNumber).subscribe(
      (adjustmentList) => {
        this.appliedRevenue = adjustmentList;
      },
      (err: any) => {
        let errorLogEntry: dbErrorEntry = new dbErrorEntry();

        errorLogEntry.Location = 'Err: invoice-add-revenue.ts::getRevenueAdjustmentList().';
        errorLogEntry.errorMessage = JSON.stringify(err);

        this.apnUtilityService.logErrorToDB(errorLogEntry);
      },
      () => {
        let ii: number = 0;
        for (ii = 0; ii < this.appliedRevenue.length; ii++) {
          this.appliedRevenue[ii].revenueTypeName = this.getRevenueTypeNameFromCode(
            this.appliedRevenue[ii].revenueType,
          );
        }
      },
    );
  }

  getRevenueTypeNameFromCode(revenueTypeCode: string): string {
    let ii: number = 0;
    let revenueTypeName: string = '';

    try {
      for (ii = 0; this.revenueTypes.length; ii++) {
        if (this.revenueTypes[ii].code === revenueTypeCode) {
          revenueTypeName = this.revenueTypes[ii].description;
          break;
        }

        if (this.revenueTypes[ii].nonTaxableCode === revenueTypeCode) {
          revenueTypeName = this.revenueTypes[ii].description;
          break;
        }
      }
    } catch (err) {
      console.error('Error during getRevenueTypeNameFromCode: ' + JSON.stringify(err));
      revenueTypeName = '';
    }

    return revenueTypeName;
  }

  getRevenueTypeCode(): string {
    let revenueTypeCode: string;

    var e = document.getElementById('revenueType') as HTMLSelectElement;
    var sel = e.selectedIndex;
    var opt = e.options[sel];
    revenueTypeCode = (<HTMLOptionElement>opt).value;

    return revenueTypeCode;
  }

  getRevenueTypeName(): string {
    let revenueTypeCode: string;

    var e = document.getElementById('revenueType') as HTMLSelectElement;
    var sel = e.selectedIndex;
    var opt = e.options[sel];
    revenueTypeCode = (<HTMLOptionElement>opt).text;

    return revenueTypeCode;
  }

  getRevenueTypeNameByRevenueCode(revenueCode: string): string {
    let revenueTypeName: string = '';
    let ii: number;

    for (ii = 0; ii < this.revenueTypes.length; ii++) {
      if (this.revenueTypes[ii].code.toUpperCase() == revenueCode.toUpperCase()) {
        revenueTypeName = this.revenueTypes[ii].description;
      }
    }

    return revenueTypeName;
  }

  checkTaxableAttributesOfRevenueType(): boolean {
    let revenueTypeCode: string = '';

    if (this.typeRevenueCalculation == 'GROSS') revenueTypeCode = this.revenueCodeSelectedGross;
    else revenueTypeCode = this.revenueCodeSelectedNet;

    let taxableStatus: number = 0; //0 - taxable/non-taxable, 1-taxable only, 2-non-taxable only, Set to 2 by default

    let ii: number = 0;

    for (ii = 0; ii < this.revenueTypes.length; ii++) {
      if (revenueTypeCode == this.revenueTypes[ii].code) {
        if (this.revenueTypes[ii].isTaxAndNoTax) {
          taxableStatus = 0;
        }

        if (this.revenueTypes[ii].isTaxableOnly) {
          taxableStatus = 1;
        }

        if (this.revenueTypes[ii].isNonTaxableOnly) {
          taxableStatus = 2;
        }
      }
    }

    if (taxableStatus == 1) {
      const dialogRef = this.dialog.open(NotifyTaxOnlyComponent, {
        width: '900px',
        height: '270px',
        position: { top: '75px' },
      });

      dialogRef.afterClosed().subscribe((result) => {
        if (this.typeRevenueCalculation == 'GROSS') this.addRevenueIsTaxableCheckBoxGross = true;
        else this.addRevenueIsTaxableCheckBoxNet = true;

        this.taxableRevenueShouldBeApplied = true;
      });
    }

    if (taxableStatus == 2) {
      const dialogRef = this.dialog.open(NotifyNoTaxOnlyComponent, {
        width: '900px',
        height: '270px',
        position: { top: '75px' },
      });

      dialogRef.afterClosed().subscribe((result) => {
        if (this.typeRevenueCalculation == 'GROSS') this.addRevenueIsTaxableCheckBoxGross = false;
        else this.addRevenueIsTaxableCheckBoxNet = false;

        this.taxableRevenueShouldBeApplied = false;
      });
    }

    return taxableStatus == 0;
  }

  confirmChangeTaxesFromAddedRevenue() {
    let changeTaxableStatus: boolean = this.checkTaxableAttributesOfRevenueType();

    if (false == changeTaxableStatus) {
      return;
    }

    if (this.taxableRevenueShouldBeApplied === true) {
      const dialogRef = this.dialog.open(ConfirmRemoveTaxComponent, {
        width: '900px',
        height: '270px',
        position: { top: '75px' },
      });

      //return when dialog closed and process if proceed or cancel
      dialogRef.afterClosed().subscribe((result) => {
        if (result == true) {
          if (this.typeRevenueCalculation == 'GROSS') this.addRevenueIsTaxableCheckBoxGross = false;
          else this.addRevenueIsTaxableCheckBoxNet = false;

          this.taxableRevenueShouldBeApplied = false;
        } else {
          if (this.typeRevenueCalculation == 'GROSS') this.addRevenueIsTaxableCheckBoxGross = true;
          else this.addRevenueIsTaxableCheckBoxNet = true;

          this.taxableRevenueShouldBeApplied = true;
        }

        if (this.typeRevenueCalculation == 'GROSS') this.onCalculateRateFromGrossRate();
        else this.onCalculateRateFromNetRate();
      });
    } else {
      const dialogTurnTaxOnRef = this.dialog.open(ConfirmAddTaxComponent, {});
      dialogTurnTaxOnRef.afterClosed().subscribe((result) => {
        if (result == true) {
          if (this.typeRevenueCalculation == 'GROSS') this.addRevenueIsTaxableCheckBoxGross = true;
          else this.addRevenueIsTaxableCheckBoxNet = true;

          this.taxableRevenueShouldBeApplied = true;
        } else {
          if (this.typeRevenueCalculation == 'GROSS') this.addRevenueIsTaxableCheckBoxGross = false;
          else this.addRevenueIsTaxableCheckBoxNet = false;

          this.taxableRevenueShouldBeApplied = false;
        }
        if (this.typeRevenueCalculation == 'GROSS') this.onCalculateRateFromGrossRate();
        else this.onCalculateRateFromNetRate();
      });
    }
  }

  calculateTotalRevenue(): void {
    let totalTaxRate: number = this.calculateTotalTaxRate();
    let subTotalRate: number;
    let formattedRateSubtotal: any;
    let formattedRateTotal: any;

    //let revenueRate:number = this.getRevenueRateForCalc();
    //this.currentRevenueRate = revenueRate;

    //check for valid quantity and rate, exit if not valid
    if (this.currentRevenueRate === 0 || this.currentRevenueRate === null) {
      return;
    }

    if (this.addedRevenueQuantity <= 0 || this.addedRevenueQuantity === null) {
      return;
    }

    this.totalCalcedAddedRevenue = this.addedRevenueQuantity * this.currentRevenueRate;

    if (totalTaxRate > 0 && this.taxableRevenueShouldBeApplied) {
      let revenueTaxAmount: number;
      this.subtotalCalcedAddedRevenue = this.currentRevenueRate * this.addedRevenueQuantity;
      revenueTaxAmount = this.subtotalCalcedAddedRevenue * totalTaxRate;
      this.totalCalcedAddedRevenue = this.subtotalCalcedAddedRevenue + revenueTaxAmount;
    } else {
      this.subtotalCalcedAddedRevenue = this.addedRevenueQuantity * this.currentRevenueRate;
    }

    if (this.currentRevenueRate === 0 || this.addedRevenueQuantity <= 0) {
      this.subtotalCalcedAddedRevenue = 0;
      this.totalCalcedAddedRevenue = 0;
    }

    formattedRateSubtotal = this.decimalPipe.transform(this.subtotalCalcedAddedRevenue, '1.2-2')?.toString();
    formattedRateTotal = this.decimalPipe.transform(this.totalCalcedAddedRevenue, '1.2-2')?.toString();

    this.taxForRevenueAdjustmentTax = +this.decimalPipe
      .transform(this.totalCalcedAddedRevenue - this.subtotalCalcedAddedRevenue, '1.2-2')
      ?.toString()!;

    this.subtotalCalcedAddedRevenue = formattedRateSubtotal;

    this.totalCalcedAddedRevenue = formattedRateTotal;

    this.isRevenueDataValidated();
  }

  parseFloatIgnoreCommas(theNumber: string): number {
    var numberNoCommas = theNumber.replace(/,/g, '');
    return parseFloat(numberNoCommas);
  }

  validateAddedRevenue(): boolean {
    let isValid: boolean = true;

    this.addedRevenueValidation = new AddedRevenueValidation();
    this.addedRevenueValidation.isValid = true;

    //Validate Rate
    let rateAmountString = (<HTMLInputElement>document.getElementById('revenueRate')).value;
    if (rateAmountString === '' || rateAmountString === '0') {
      this.addedRevenueValidation.isValid = false;
      this.addedRevenueValidation.rateAmountMessage = 'Rate must be greater than $0';
    }

    if (this.addedRevenueValidation.isValid === true) {
      let rateAmountNumber: number = this.parseFloatIgnoreCommas(rateAmountString);
      if (rateAmountNumber <= 0) {
        this.addedRevenueValidation.isValid = false;
        this.addedRevenueValidation.rateAmountMessage = 'Rate must be greater than $0';
      }
    }

    //Validate Quantity
    let rateQuantityString = (<HTMLInputElement>document.getElementById('revenueQuantity')).value;

    if (rateQuantityString === '' || rateQuantityString === '0') {
      this.addedRevenueValidation.isValid = false;
      this.addedRevenueValidation.quantityMessage = 'Quantity must be greater than $0';
    }

    if (this.addedRevenueValidation.isValid === true) {
      let rateAmountNumber: number = parseInt(rateQuantityString);
      if (rateAmountNumber <= 0) {
        this.addedRevenueValidation.isValid = false;
        this.addedRevenueValidation.quantityMessage = 'Quantity must be greater than $0';
      }
    }

    //Validate Description
    let description = (<HTMLInputElement>document.getElementById('revenueDescription')).value;

    if (description === '') {
      this.addedRevenueValidation.isValid = false;
      this.addedRevenueValidation.descriptionMessage = 'Enter description before adding revenue';
    }

    let revenueType: string = (<HTMLOptionElement>document.getElementById('revenueType')).value;
    if (revenueType === '0') {
      this.addedRevenueValidation.isValid = false;
    }

    isValid = this.addedRevenueValidation.isValid;

    return isValid;
  }

  isGrossRevenueAddValidated(): void {
    this.inputValidatedGross = false;

    if (this.revenueCodeSelectedGross == '') return;

    if (this.grossRate == 0 || this.grossRate == null) return;

    if (this.grossQuantity == 0) return;

    if (this.revenueDescriptionGross == '') return;

    this.inputValidatedGross = true;
  }

  isNetRevenueAddValidated(): void {
    this.inputValidatedNet = false;

    if (this.revenueCodeSelectedNet == '') return;

    if (this.netRateValue == 0 || this.netRateValue == null) return;

    if (this.netQuantity == 0) return;

    if (this.revenueDescriptionNet == '') return;

    this.inputValidatedNet = true;
  }

  isRevenueDataValidated(): void {
    if (this.typeRevenueCalculation == 'GROSS') this.isGrossRevenueAddValidated();
    else this.isNetRevenueAddValidated();
  }

  isRevenueTypeNonTaxOnly(revenueTypeCode: string): boolean {
    let ii: number = 0;
    let isOnlyNonTaxable = false;

    for (ii = 0; ii < this.revenueTypes.length; ii++) {
      if (this.revenueTypes[ii].code === revenueTypeCode) {
        isOnlyNonTaxable = this.revenueTypes[ii].isNonTaxableOnly === true;
      }
    }
    return isOnlyNonTaxable;
  }

  onChangeResetRevenueDataGross(): void {
    // (<HTMLInputElement>document.getElementById('revenueRate')).value = '0';
    // (<HTMLInputElement>document.getElementById('revenueQuantity')).value = '';

    this.subtotalCalcedAddedRevenue = 0;
    this.totalCalcedAddedRevenue = 0;
    this.revenueDescription = '';

    //TaxApplied - enable and check
    if (this.typeRevenueCalculation == 'GROSS') this.addRevenueIsTaxableCheckBoxGross = true;
    else this.addRevenueIsTaxableCheckBoxNet = true;

    this.taxableRevenueShouldBeApplied = true;

    //Set the disabled status of the tax applied checkbox
    this.isTaxCheckboxReadOnly = this.revenueCodeSelectedGross == '' ? true : false;

    //Determine what type of revenue type and whether is non-tax only
    //let revenueTypeCode:string = (<HTMLOptionElement>document.getElementById('revenueCodeSelected')).value;

    let isThisRevenueCodeNonTaxableOnly = this.isRevenueTypeNonTaxOnly(this.revenueCodeSelectedGross);

    //TaxApplied - enable and check
    if (isThisRevenueCodeNonTaxableOnly) {
      if (this.typeRevenueCalculation == 'GROSS') this.addRevenueIsTaxableCheckBoxGross = false;
      else this.addRevenueIsTaxableCheckBoxNet = false;

      this.taxableRevenueShouldBeApplied = false;
    } else {
      if (this.typeRevenueCalculation == 'GROSS') this.addRevenueIsTaxableCheckBoxGross = true;
      else this.addRevenueIsTaxableCheckBoxNet = true;

      this.taxableRevenueShouldBeApplied = true;
    }

    if (this.typeRevenueCalculation == 'GROSS') {
      this.onCalculateRateFromGrossRate();
      this.isGrossRevenueAddValidated();
      this.onResetAddRevenueDataGross();
    } else {
      this.onCalculateRateFromNetRate();
      this.isNetRevenueAddValidated();
      this.onResetAddRevenueDataNet();
    }
  }

  onChangeResetRevenueData(): void {
    // (<HTMLInputElement>document.getElementById('revenueRate')).value = '0';
    // (<HTMLInputElement>document.getElementById('revenueQuantity')).value = '';
    this.subtotalCalcedAddedRevenue = 0;
    this.totalCalcedAddedRevenue = 0;
    this.revenueDescription = '';

    //Set the disabled status of the tax applied checkbox
    this.isTaxCheckboxReadOnly = this.revenueCodeSelectedNet == '' ? true : false;

    //TaxApplied - enable and check
    if (this.typeRevenueCalculation == 'GROSS') this.addRevenueIsTaxableCheckBoxGross = true;
    else this.addRevenueIsTaxableCheckBoxNet = true;

    this.taxableRevenueShouldBeApplied = true;

    let isThisRevenueCodeNonTaxableOnly = this.isRevenueTypeNonTaxOnly(this.revenueCodeSelectedNet);

    //TaxApplied - enable and check
    if (isThisRevenueCodeNonTaxableOnly) {
      if (this.typeRevenueCalculation == 'GROSS') this.addRevenueIsTaxableCheckBoxGross = false;
      else this.addRevenueIsTaxableCheckBoxNet = false;
      this.taxableRevenueShouldBeApplied = false;
    } else {
      if (this.typeRevenueCalculation == 'GROSS') this.addRevenueIsTaxableCheckBoxGross = true;
      else this.addRevenueIsTaxableCheckBoxNet = true;

      this.taxableRevenueShouldBeApplied = true;
    }

    if (this.typeRevenueCalculation == 'GROSS') {
      this.onCalculateRateFromGrossRate();
      this.isGrossRevenueAddValidated();
    } else {
      this.onCalculateRateFromNetRate();
      this.isNetRevenueAddValidated();
      this.onResetAddRevenueDataNet();
    }
  }

  onFinishAddRevenueDataGross(): void {
    this.revenueCodeSelectedGross = '';
    this.onResetAddRevenueDataGross();
  }

  onFinishAddRevenueDataNet(): void {
    this.revenueCodeSelectedNet = '';
    this.onResetAddRevenueDataNet();
  }

  onResetAddRevenueDataGross(): void {
    try {
      this.addRevenueIsTaxableCheckBoxGross = true;
      this.grossRate = 0;
      this.grossQuantity = 0;
      this.revenueDescriptionGross = '';
      this.netRate = 0;
      this.grossDisplayNet = 0;
      this.grossDisplayAmount = 0;
      this.grossDisplayTaxAmount = 0;
      this.grossTotalTaxRate = this.calculateTotalTaxRate();
      this.inputValidatedGross = false; //disable submit button
    } catch (err) {}
  }

  onResetAddRevenueDataNet(): void {
    try {
      this.addRevenueIsTaxableCheckBoxNet = true;
      this.grossRate = 0;
      this.netQuantity = 0;
      this.revenueDescription = '';
      this.netRateValue = 0;
      this.netDisplayTotalNet = 0;
      this.netDisplayTaxAmount = 0;
      this.netDisplayTotalAmount = 0;
      this.grossTotalTaxRate = this.calculateTotalTaxRate();
      this.inputValidatedNet = false; //disable submit button
      this.revenueDescriptionNet = '';
    } catch (err) {}
  }

  setRevenueRate() {
    let rateToDisplay: any = this.decimalPipe.transform(this.calcRate, '1.4-4');

    this.currentRevenueRate = rateToDisplay;

    (<HTMLInputElement>document.getElementById('revenueRate')).value = rateToDisplay;
  }

  onCalculateRateFromGrossRate(): void {
    //don't calc if we don't have a gross rate or quantity

    try {
      if (this.grossRate <= 0 || this.grossQuantity <= 0) {
        return;
      }

      let grossRate: number = +this.grossRate;
      let grossQuantity: number = +this.grossQuantity;

      //This is the calculation for determining the Rate when entering the Gross Rate for Added Revenue
      //Order of Operations as follows - It's important to do base calcs per unit prior to multiplying for quantity
      if (this.taxableRevenueShouldBeApplied) {
        //**** START OF GROSS CALC WITH TAX ****/

        //Step 1. Calculate the rate per unit - which is the rate before tax is applied
        let ratePerUnit = +this.decimalPipe
          .transform(grossRate / (1 + this.grossTotalTaxRate), '1.2-2')
          .replace(',', '')!;

        //This adds the value to the variable that is bound to the UI elements
        this.netRate = +ratePerUnit;

        //Step 2. Calculate the tax per individual unit (before rate * quantity) value by subtracting the gross rate - the net rate (before tax)
        let taxPerUnit = +this.decimalPipe.transform(this.grossRate - this.netRate, '1.2-2').replace(',', '')!;

        //Step 2.  Calculate the total tax
        let totalTax: number = taxPerUnit * this.grossQuantity;

        //Step 3. Calculate the total amount of the rate prior to tax
        let totalNet: number = this.netRate * this.grossQuantity;

        //Step 4: Calculate the total gross value, which = (net * quantity) + (tax * quantity)
        let totalGrossAmount: number = totalNet + totalTax;

        //The following don't perform calculations, but assign to variables which are bound to the UI Elements
        this.grossDisplayAmount = totalGrossAmount;
        this.grossDisplayNet = totalNet;
        this.grossDisplayTaxAmount = totalTax;

        //**** END OF GROSS CALC WITH TAX ****/
      } else {
        //**** START OF GROSS CALC WITHOUT TAX ****/

        //Step 1: Calculate Total Gross Amount - Same for RATE and TOTAL since no tax
        this.grossDisplayAmount = grossRate * grossQuantity;

        //Step 2: Calculate Total Gross Amount for Net - Same for RATE and TOTAL since no tax
        this.grossDisplayNet = grossRate * grossQuantity;

        //Step 3: Set Tax UI element to 0 to reflect no tax
        this.grossDisplayTaxAmount = 0;

        //Step 4: Set the Individual Net Rate - performs calc
        let netCalcRate: number = this.grossDisplayNet / grossQuantity;

        //Step 4: Set the Individual Net Rate value to the UI element
        this.netRate = +this.decimalPipe.transform(netCalcRate, '1.2-2')!;

        //**** END OF GROSS CALC WITHOUT TAX ****/
      }
    } catch (err) {
      console.error('Error: ' + JSON.stringify(err));
    }
    this.isGrossRevenueAddValidated();
  }

  //This is the calculation for determining the Rate when the user specifies determine by entering the Net Rate for Added Revenue
  //Order of Operations as follows - It's important to do base calcs per unit prior to multiplying for quantity
  onCalculateRateFromNetRate(): void {
    //don't calc if we don't have a gross rate or quantity
    if (this.netRateValue <= 0 || this.netQuantity <= 0) return;

    //This is the calculation for determining the Rate when entering the Net Rate
    //Order of Operations as follows - It's important to do base calcs per unit prior to multiplying for quantity
    if (this.taxableRevenueShouldBeApplied) {
      //**** START OF GROSS CALC WITH TAX ****/

      //Step 1: Get the total Net Value
      this.netDisplayTotalNet = this.netRateValue * this.netQuantity;

      //Step 2: Get the total amount of tax
      this.netDisplayTaxAmount = this.netDisplayTotalNet * this.grossTotalTaxRate;

      //Step 3: Get the Total Amount = (Rate * Quantity) + (Tax Amount * Quantity)
      this.netDisplayTotalAmount = this.netDisplayTotalNet + this.netDisplayTaxAmount;

      //Step 4. Display only two decimals in the Net Rate UI element
      this.netRate = +this.decimalPipe.transform(this.netRate, '1.2-2')!;

      //**** END OF NET CALC WITH TAX ****/
    } else {
      //Same Order of Operations as taxable, except setting the tax amount = $0

      //**** START OF NET CALC WITHOUT TAX ****/
      this.netDisplayTotalNet = this.netRateValue * this.netQuantity;
      this.netDisplayTaxAmount = 0;
      this.netDisplayTotalAmount = this.netDisplayTotalNet + this.netDisplayTaxAmount;
      this.netRate = +this.decimalPipe.transform(this.netRate, '1.2-2')!;

      //**** END OF NET CALC WITHOUT TAX ****/
    }

    this.isNetRevenueAddValidated();
  }

  calculateGrossNetTaxes(): void {
    let totalTaxRate: number = this.calculateTotalTaxRate();

    this.addedRevenueRate = this.netTaxAmount + this.baseTaxToCalcFrom;

    let formattedRevRate: any;

    this.calcRate = this.baseTaxToCalcFrom / (1 + totalTaxRate);

    formattedRevRate = this.decimalPipe.transform(this.addedRevenueRate, '1.2-2')?.toString();

    this.addedRevenueRate = formattedRevRate;

    this.calcTotalAmount = this.baseTaxToCalcFrom;

    this.calcTaxAmount = this.calcTotalAmount - this.calcRate;
  }

  calculateTotalTaxRate(): number {
    let i: number = 0;
    let totalTaxRate: number = 0;

    for (i = 0; i < this.activeTaxListForLot.length; i++) {
      totalTaxRate += this.activeTaxListForLot[i].taxAmount;
    }

    //set class level var
    this.totalTaxRate = totalTaxRate;

    return totalTaxRate;
  }
}
